var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('ve-line',{attrs:{"extend":_vm.chartExtend,"data":_vm.chartData,"settings":_vm.chartSettings}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }